import {Box} from '@mui/material';
import React from 'react';

interface Props {
  children: React.ReactNode;
}

const PageTitleContainer: React.FC<Props> = ({children}) => (
  <Box
    sx={{
      mb: 3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'bottom',
    }}>
    {children}
  </Box>
);

export default PageTitleContainer;
